import React, { useState } from 'react';

import {
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Button,
  Portal,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';

import DeleteSkuModal from './DeleteSkuModal';
import PublishSkuToStoreModal from './PublishSkuToStoreModal';

const SkuOptionsMenu = ({ row, onDeleted, onUpdated }) => {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [publishOpen, setPublishOpen] = useState(false);

  return (
    <>
      <Popover placement="bottom-end">
        <PopoverTrigger>
          <IconButton
            aria-label="SKU options"
            icon={<HamburgerIcon />}
            size="xs"
            variant="ghost"
          />
        </PopoverTrigger>
        <Portal>
          <PopoverContent w="auto">
            <PopoverBody p={2}>
              <Button
                size="sm"
                colorScheme="teal"
                variant="ghost"
                w="full"
                justifyContent="flex-start"
                mb={1}
                onClick={() => setPublishOpen(true)}
              >
                List on another store
              </Button>
              <Button
                size="sm"
                colorScheme="red"
                variant="ghost"
                w="full"
                justifyContent="flex-start"
                onClick={() => setDeleteOpen(true)}
              >
                Delete SKU & listings
              </Button>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>

      <PublishSkuToStoreModal
        isOpen={publishOpen}
        onClose={() => setPublishOpen(false)}
        row={row}
        onPublished={onUpdated}
      />

      <DeleteSkuModal
        isOpen={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        row={row}
        onDeleted={onDeleted}
      />
    </>
  );
};

export default SkuOptionsMenu;
